module.exports = __webpack_public_path__ + "static/media/password.737d1827.svg";